// Entry point for the build script in your package.json
import "@hotwired/turbo-rails";
import { StreamActions } from "@hotwired/turbo";
import TurboPower from "turbo_power";
TurboPower.initialize(StreamActions);
import "./controllers";

import "preline";
import "trix";
import "@rails/actiontext";
import "chartkick/chart.js";
import "long-press-event";
import { SessionState } from "sip.js";

document.addEventListener("turbo:load", () => {
  window.HSStaticMethods.autoInit();
});

document.addEventListener("turbo:load", () => {
  document.querySelectorAll("turbo-frame[src]").forEach((el) => {
    if (!el.hasAttribute("data-controller")) {
      //      el.setAttribute("data-controller", "reload");
    }
  });
});

window.addEventListener(
  "beforeunload",
  (event) => {
    if (hasActiveCall()) {
      // ✅ Use preventDefault on the event
      event.preventDefault();
      event.stopImmediatePropagation();
      // Include returnValue for legacy browser support
      event.returnValue = "";
      return true;
    }
  },
  { capture: true },
);

function hasActiveCall() {
  return (
    window.registry?.user?.session ||
    window.registry?.user?.session?.state === SessionState.Established
  );
}
